/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-base-to-string */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { GfaServiceConfigProviderV1 } from './feature-service-types';

export interface AcsResult {
  caeDataRequired: boolean;
}

export interface FetchCaeEnforcementInput {
  gfaServiceConfigProvider?: GfaServiceConfigProviderV1;
}

const ACS_TIMEOUT_MS = 5000;
const inflight = new Map<string, Promise<AcsResult>>();
const DEFAULT_ACS_APPLICATION = 'market-context';

function buildAcsUrl(gfaServiceConfigProvider?: GfaServiceConfigProviderV1): string | null {
  const acsConfig = gfaServiceConfigProvider?.gfa?.acs;
  if (!acsConfig?.origin || !acsConfig?.path) return null;

  const tenant = acsConfig.customConfig?.tenant ?? '';
  const application = acsConfig.customConfig?.application ?? DEFAULT_ACS_APPLICATION;
  return `${acsConfig.origin}${acsConfig.path}?tenant=${encodeURIComponent(String(tenant))}&application=${encodeURIComponent(String(application))}`;
}

async function doFetch(url: string): Promise<AcsResult> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), ACS_TIMEOUT_MS);

  try {
    const response = await fetch(url, { signal: controller.signal });
    const data = (await response.json()) as { configuration?: unknown };

    const rawConfiguration = data?.configuration;
    let parsedConfiguration: Record<string, unknown> | null = null;

    if (typeof rawConfiguration === 'string') {
      try {
        parsedConfiguration = JSON.parse(rawConfiguration) as Record<string, unknown>;
      } catch {
        parsedConfiguration = null;
      }
    } else if (rawConfiguration && typeof rawConfiguration === 'object') {
      parsedConfiguration = rawConfiguration as Record<string, unknown>;
    }

    const normalizedValue =
      parsedConfiguration &&
      Object.entries(parsedConfiguration).find(
        ([key]) => key.trim() === 'cae_data_required' || key.trim() === 'caeDataRequired',
      )?.[1];

    const caeDataRequired =
      normalizedValue === true ||
      normalizedValue === 'true' ||
      (typeof normalizedValue === 'string' && normalizedValue.trim().toLowerCase() === 'true');

    return { caeDataRequired };
  } catch {
    return { caeDataRequired: false };
  } finally {
    clearTimeout(timeoutId);
  }
}

export async function fetchCaeEnforcement({
  gfaServiceConfigProvider,
}: FetchCaeEnforcementInput): Promise<AcsResult> {
  const DEFAULT_ACS_URL = process.env.MARKET_CONTEXT_SERVICE_ACS_URL;

  const url = buildAcsUrl(gfaServiceConfigProvider) || DEFAULT_ACS_URL;

  if (!url) return { caeDataRequired: false };

  if (inflight.has(url)) return inflight.get(url)!;
  const promise = doFetch(url).finally(() => inflight.delete(url));
  inflight.set(url, promise);
  return promise;
}
